import { all } from 'redux-saga/effects';
import carrierRegistrationdSaga from './CarrierRegistration/CarrierRegistrationSagas';
import LossAndDamageClaims from './Claims/LossAndDamage/LossAndDamageClaimsSagas';
import OverChargeClaimsSaga from './Claims/OverCharge/OverChargeSagas';
import PreClaimsSaga from './Claims/PreClaims/PreClaimsSagas';
import dashboardSaga from './Dashboard/DashboardSagas';
import MessageCenterSaga from './MessageCenter/MessageCenterSagas';
import POShipmentDraftSearchSaga from './POShipmentDraftSearch/POShipmentDraftSearchSagas';
import POShipmentPreBookingSearchSaga from './POShipmentPreBookingSearch/POShipmentPreBookingSearchSagas';
import POShipmentSearchSaga from './POShipmentSearch/POShipmentSearchSagas';
import POVSagas from './POV/POVSagas';
import procurementProjectSaga from './Procurement/Project/ProcurementProjectSagas';
import procurementLaneSaga from './Procurement/RouteConfig/Lane/ProcurementLaneSagas';
import procurementLocationSaga from './Procurement/RouteConfig/Location/ProcurementLocationSagas';
import procurementZoneSaga from './Procurement/RouteConfig/Zone/ProcurementZoneSagas';
import procurementTenderSaga from './Procurement/Tender/ProcurementTenderSagas';
import RateShopSaga from './RateShop/RateShopSagas';
import routguideSaga from './RoutingGuide/RoutingGuideSagas';
import saversSaga from './Savers/SaversSagas';
import AuctionSaga from './auction/AuctionSagas';
import authSaga from './auth/AuthSagas';
import commonSaga from './common/CommonSagas';
import LookupsSaga from './lookups/LookupsSagas';
import PurchaseOrderSagas from './purchaseOrder/PurchaseOrderSagas';
import settingsSaga from './settings/SettingsSagas';
import shipmentSaga from './shipment/ShipmentSagas';
import visibilitySaga from './visibility/VisibilitySagas';

export default function* rootSaga() {
  yield all([
    commonSaga(),
    authSaga(),
    dashboardSaga(),
    carrierRegistrationdSaga(),
    shipmentSaga(),
    PurchaseOrderSagas(),
    POVSagas(),
    AuctionSaga(),
    settingsSaga(),
    visibilitySaga(),
    LookupsSaga(),
    RateShopSaga(),
    procurementProjectSaga(),
    procurementTenderSaga(),
    POShipmentSearchSaga(),
    procurementLocationSaga(),
    procurementZoneSaga(),
    procurementLaneSaga(),
    POShipmentDraftSearchSaga(),
    POShipmentPreBookingSearchSaga(),
    OverChargeClaimsSaga(),
    MessageCenterSaga(),
    routguideSaga(),
    PreClaimsSaga(),
    LossAndDamageClaims(),
    saversSaga(),
  ]);
}
